import {SiteDTO} from "../../dtos/site-dto";
import {TrancheReductionMl} from "./tranche-reduction-ml";

export class ParametreCalculConditionnementMl {
  siteId: number;
  siteLibelle: string;
  siteLocal: boolean;
  minimumBarquetteRequired: Number;
  trancheReductionList: TrancheReductionMl[];
  isEdited: boolean = false;

  constructor(site: SiteDTO) {
    this.siteId = site.id;
    this.siteLibelle = site.libelle;
    this.siteLocal = false;
    this.minimumBarquetteRequired = 4;
    this.trancheReductionList = [new TrancheReductionMl()];
  }

  public setEdited() {
    if (!this.isEdited) {
      this.isEdited = true;
      this.siteLibelle = `${this.siteLibelle} *`;
    }
  }
}
